<div class="vc-online-booking-share vc-view-shell">
  <main class="vc-online-booking-share__layout vc-view-content">
    <section class="vc-online-booking-share__frame vc-surface-panel">
      <div class="vc-online-booking-share__content">
        <article class="vc-card vc-card--compact" *ngIf="loading">
          <p class="vc-online-booking-share__loading">
            {{ "ONLINE_BOOKING_SHARE.LOADING" | translate }}
          </p>
        </article>

        <ng-container *ngIf="!loading">
          <section class="vc-alert" [ngClass]="active ? 'vc-alert--success' : 'vc-alert--warning'">
            <i
              class="vc-alert__icon"
              [ngClass]="active ? 'fas fa-circle-check' : 'fas fa-triangle-exclamation'"
            ></i>
            <div class="vc-alert__content">
              <p class="vc-alert__title">
                {{
                  (active
                    ? "ONLINE_BOOKING_SHARE.STATUS.ACTIVE_TITLE"
                    : "ONLINE_BOOKING_SHARE.STATUS.INACTIVE_TITLE") | translate
                }}
              </p>
              <p class="vc-alert__message">
                {{
                  (active
                    ? "ONLINE_BOOKING_SHARE.STATUS.ACTIVE_MESSAGE"
                    : "ONLINE_BOOKING_SHARE.STATUS.INACTIVE_MESSAGE") | translate
                }}
              </p>
            </div>
          </section>

          <div class="vc-grid vc-grid--responsive-2 vc-online-booking-share__cards">
            <article class="vc-card">
              <div class="vc-card__header">
                <div class="vc-online-booking-share__card-copy">
                  <h2 class="vc-card__title">{{ "ONLINE_BOOKING_SHARE.LINK.TITLE" | translate }}</h2>
                  <p class="vc-card__subtitle">
                    {{ "ONLINE_BOOKING_SHARE.LINK.DESCRIPTION" | translate }}
                  </p>
                </div>
              </div>

              <div class="vc-online-booking-share__url-box">{{ publicBookingUrl }}</div>

              <div class="vc-card__footer vc-online-booking-share__card-actions">
                <button type="button" class="vc-online-booking-share__button" (click)="copyLink()">
                  {{ "ONLINE_BOOKING_SHARE.ACTIONS.COPY" | translate }}
                </button>
                <button
                  type="button"
                  class="vc-online-booking-share__button vc-online-booking-share__button--secondary"
                  (click)="openPublicBooking()"
                >
                  {{ "ONLINE_BOOKING_SHARE.ACTIONS.OPEN" | translate }}
                </button>
              </div>

              <p class="vc-success-text vc-online-booking-share__feedback" *ngIf="copyFeedbackKey">
                {{ copyFeedbackKey | translate }}
              </p>
            </article>

            <article class="vc-card">
              <div class="vc-card__header">
                <div class="vc-online-booking-share__card-copy">
                  <h2 class="vc-card__title">{{ "ONLINE_BOOKING_SHARE.QR.TITLE" | translate }}</h2>
                  <p class="vc-card__subtitle">
                    {{ "ONLINE_BOOKING_SHARE.QR.DESCRIPTION" | translate }}
                  </p>
                </div>
              </div>

              <div class="vc-online-booking-share__qr-frame">
                <img
                  [src]="qrPreviewUrl"
                  [alt]="'ONLINE_BOOKING_SHARE.QR.ALT' | translate"
                />
              </div>

              <div class="vc-card__footer vc-online-booking-share__card-actions">
                <button
                  type="button"
                  class="vc-online-booking-share__button"
                  [disabled]="downloadingQr"
                  (click)="downloadQrPng()"
                >
                  {{
                    (downloadingQr
                      ? "ONLINE_BOOKING_SHARE.ACTIONS.DOWNLOADING"
                      : "ONLINE_BOOKING_SHARE.ACTIONS.DOWNLOAD") | translate
                  }}
                </button>
              </div>
            </article>
          </div>

          <article class="vc-card vc-card--compact">
            <div class="vc-card__header">
              <div class="vc-online-booking-share__card-copy">
                <h2 class="vc-card__title">{{ "ONLINE_BOOKING_SHARE.TIPS.TITLE" | translate }}</h2>
                <p class="vc-card__subtitle">
                  {{ "ONLINE_BOOKING_SHARE.TIPS.SUBTITLE" | translate }}
                </p>
              </div>
            </div>

            <ul class="vc-online-booking-share__tips-list">
              <li>{{ "ONLINE_BOOKING_SHARE.TIPS.ITEM_1" | translate }}</li>
              <li>{{ "ONLINE_BOOKING_SHARE.TIPS.ITEM_2" | translate }}</li>
              <li>{{ "ONLINE_BOOKING_SHARE.TIPS.ITEM_3" | translate }}</li>
              <li>{{ "ONLINE_BOOKING_SHARE.TIPS.ITEM_4" | translate }}</li>
            </ul>
          </article>

          <section class="vc-alert vc-alert--danger" *ngIf="errorMessageKey">
            <i class="fas fa-circle-exclamation vc-alert__icon"></i>
            <div class="vc-alert__content">
              <p class="vc-alert__title">{{ "COMMON.WARNING" | translate }}</p>
              <p class="vc-alert__message">{{ errorMessageKey | translate }}</p>
            </div>
          </section>
        </ng-container>
      </div>
    </section>
  </main>
</div>
